import { Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import React, { FC } from "react";
import Checkbox from "shared/components/Checkbox";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import TextField from "shared/components/Form/TextField";
import {
  COLOR_BLACK,
  COLOR_GREY_6,
  COLOR_PRIMARY_MAIN,
} from "shared/theme/colors";
import { usePageDetails } from "../../../../context";
import { pageIcons } from "./constants";
import { IconListContainer, IconWrapper } from "./styled";

const General: FC = () => {
  const {
    onChangePageName,
    pageDescription,
    pageName,
    pageWebTitle,
    showInBurgerMenu,
    setShowInBurgerMenu,
    showInDesktopHeaderMenu,
    setShowInDesktopHeaderMenu,
    showInMobileBurgerMenuQuickLinks,
    setShowInMobileBurgerMenuQuickLinks,
    hasSearch,
    setHasSearch,
    icon,
    setIcon,
  } = usePageDetails();

  return (
    <>
      <ContentSection title="General">
        <Stack spacing="1rem">
          <TextField
            id="pageName"
            label="Name*"
            placeholder="Name"
            fullWidth
            required
            value={pageName?.input.value}
            onChange={onChangePageName}
            errors={pageName?.input.errors}
            labelColor={COLOR_BLACK}
          />
          <TextField
            id="pageWebTitle"
            label="Page web title"
            placeholder="Enter page web title"
            fullWidth
            value={pageWebTitle?.input.value}
            onChange={pageWebTitle?.input.onChange}
            errors={pageWebTitle?.input.errors}
            labelColor={COLOR_BLACK}
          />
          <TextField
            id="pageDescription"
            label="Admin Notes"
            fullWidth
            placeholder="Description (optional)"
            required
            value={pageDescription?.input.value}
            onChange={pageDescription?.input.onChange}
            labelColor={COLOR_BLACK}
          />
        </Stack>
        <Stack mt="1rem" spacing="0.5rem">
          <Typography
            variant="bodySMedium"
            fontWeight={500}
            color={COLOR_BLACK}
          >
            Menu icon*
          </Typography>
          <IconListContainer>
            {pageIcons.map(({ name, Component }) => (
              <IconWrapper key={name} onClick={() => setIcon(name)}>
                <Component
                  color={icon === name ? COLOR_PRIMARY_MAIN : COLOR_GREY_6}
                />
              </IconWrapper>
            ))}
          </IconListContainer>
        </Stack>
      </ContentSection>
      <ContentSection title="Page Configuration">
        <Stack spacing="1rem">
          <Checkbox
            label="Add search to page"
            checked={hasSearch}
            onChange={setHasSearch}
          />
          <Checkbox
            label="Add to desktop navigation bar"
            checked={showInDesktopHeaderMenu}
            onChange={setShowInDesktopHeaderMenu}
          />
          <Checkbox
            label="Add to mobile burger menu quick-links"
            checked={showInMobileBurgerMenuQuickLinks}
            onChange={setShowInMobileBurgerMenuQuickLinks}
          />
          <Checkbox
            label="Add to mobile burger menu list"
            checked={showInBurgerMenu}
            onChange={setShowInBurgerMenu}
          />
        </Stack>
      </ContentSection>
    </>
  );
};

export default General;
